import { render, staticRenderFns } from "./commonLable.vue?vue&type=template&id=2352a8d8&"
import script from "./commonLable.vue?vue&type=script&lang=js&"
export * from "./commonLable.vue?vue&type=script&lang=js&"
import style0 from "./commonLable.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports